import { render, staticRenderFns } from "./WesQuestionAccordion.vue?vue&type=template&id=f3ba1b8a&scoped=true"
import script from "./WesQuestionAccordion.vue?vue&type=script&lang=js"
export * from "./WesQuestionAccordion.vue?vue&type=script&lang=js"
import style0 from "./WesQuestionAccordion.vue?vue&type=style&index=0&id=f3ba1b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ba1b8a",
  null
  
)

export default component.exports